/**
 * 買取品目ページ #maker 内のメーカー一覧（SP のみ先頭10件＋「もっと見る」）
 * ブレークポイントは _variable.scss の $sp（768px）に合わせる
 */
(function () {
  var MQ = "(max-width: 768px)";
  var INITIAL_VISIBLE = 10;
  var SELECTOR = "#maker .maker_list_wrap";

  function eachNodeList(list, fn) {
    for (var i = 0; i < list.length; i++) {
      fn(list[i], i);
    }
  }

  function syncWrap(wrap) {
    var list = wrap.querySelector(".maker_list");
    var btn = wrap.querySelector(".maker_list_more");
    if (!list || !btn) return;

    var items = list.querySelectorAll(".maker_item");
    var mq = window.matchMedia(MQ);

    function setButtonState(isExpanded) {
      btn.setAttribute("aria-expanded", isExpanded ? "true" : "false");
      btn.textContent = isExpanded ? "閉じる" : "もっと見る";
    }

    function apply() {
      var wasExpanded = wrap.classList.contains("is-expanded");
      wrap.classList.remove("is-collapsed", "is-expanded", "is-short-list");

      if (!mq.matches) {
        setButtonState(false);
        return;
      }

      if (items.length <= INITIAL_VISIBLE) {
        wrap.classList.add("is-short-list");
        setButtonState(false);
        return;
      }

      if (wasExpanded) {
        wrap.classList.add("is-expanded");
        setButtonState(true);
        return;
      }

      wrap.classList.add("is-collapsed");
      setButtonState(false);
    }

    btn.addEventListener("click", function () {
      if (!mq.matches) return;

      var isExpanded = wrap.classList.contains("is-expanded");
      wrap.classList.toggle("is-expanded", !isExpanded);
      wrap.classList.toggle("is-collapsed", isExpanded);
      setButtonState(!isExpanded);
    });

    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", apply);
    } else {
      mq.addListener(apply);
    }

    apply();
  }

  function init() {
    var wraps = document.querySelectorAll(SELECTOR);
    if (!wraps.length) return;
    eachNodeList(wraps, syncWrap);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
